import React from 'react';

export function WhatIsMFA() {
  return (
    <details className="my-1 cursor-pointer  text-sm text-gray-500">
      <summary>What is an authenticator app?</summary>
      <div className="mt-2 rounded-md border border-gray-200 p-4">
        <p>
          Authenticator apps give you a simple and secure way to sign in to apps and websites. After
          logging in with your email and password as normal, you'll be prompted to type in a 6 digit
          number from the app.
        </p>
        <p className="mt-2">
          There are a number of well known Authenticator Apps, freely available on your App Stores.
        </p>
        <ul className="mt-2 ml-24 list-disc text-left">
          <li>
            <a target="_blank" href="https://2fas.com/">
              2FAs
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
            >
              Google Authenticator
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://www.microsoft.com/en-us/security/mobile-authenticator-app"
            >
              Microsoft Authenticator
            </a>
          </li>
        </ul>
      </div>
    </details>
  );
}
